import { Button, ButtonGroup } from "react-bootstrap";
import PropTypes from "prop-types";
import { useCallback } from "react";
import { useNavigate } from "react-router";

const SignInSignUpButtons = ({ activeKey, className }) => {
	const navigate = useNavigate();
	const onSelect = useCallback(() => {
		navigate(activeKey === 'sign-in' ? '/sign-up' : '/sign-in');
	}, [navigate, activeKey]);

	return (
		<ButtonGroup className={className} id="sign-in-sign-up">
			<Button
				active={activeKey === 'sign-in'}
				className="text-uppercase"
				onClick={onSelect}
				variant={activeKey === 'sign-in' ? 'primary' : 'outline-primary'}
			>
				Sign In
			</Button>
			<Button
				active={activeKey === 'sign-up'}
				className="text-uppercase"
				onClick={onSelect}
				variant={activeKey === 'sign-up' ? 'primary' : 'outline-primary'}
			>
				Sign Up
			</Button>
		</ButtonGroup>
	);
};

SignInSignUpButtons.propTypes = {
	activeKey: PropTypes.oneOf(['sign-in', 'sign-up']).isRequired,
	className: PropTypes.string,
};

SignInSignUpButtons.defaultProps = {
	className: '',
};

export default SignInSignUpButtons;